import React, { useState, useEffect, memo } from 'react';
import Select from 'b2b-ui-components-lib/lib/components/select';
import { ALL_OPTIONS, BANDWIDTHS, PRODUCT_OPTIONS, SERVICE_OPTIONS } from 'rateCard/constant/constant';
import resetIcon from '../../../assests/reset.png';
import './filters.scss';
import { FilterOptions, ITableRow } from 'rateCard/constant/rateCard.interface';

type Props = {
  onFilterChange: Function;
  resetFilters: boolean;
  options?: FilterOptions;
  onResetClikced?: Function;
};

export const Filters: React.FC<Props> = memo(({ onFilterChange, resetFilters, options, onResetClikced }) => {
  const [bandwidth, setBandwidth] = useState<any>(ALL_OPTIONS);
  const [serviceType, setServiceType] = useState<any>(ALL_OPTIONS);
  const [status, setStatus] = useState<any>(ALL_OPTIONS);

  const onBandWidthChange = (value: any) => setBandwidth(value);
  const onServiceTypeChange = (value: any) => setServiceType(value);
  const onStatusChange = (value: any) => setStatus(value);

  const onResetChange = () => {
    setBandwidth(ALL_OPTIONS);
    setServiceType(ALL_OPTIONS);
    setStatus(ALL_OPTIONS);
    onResetClikced?.();
  };

  useEffect(() => {
    onResetChange();
  }, [resetFilters]);

  useEffect(() => {
    onFilterChange?.({ bandwidth: bandwidth?.key, serviceType: serviceType?.key, status: status?.key });
  }, [bandwidth, serviceType, status]);

  return (
    <div className="filter-container">
      <Select options={options?.bandwidth ? options?.bandwidth : BANDWIDTHS} onChange={onBandWidthChange} value={bandwidth} variant="compact" label="Bandwidth" required />
      <Select
        options={options?.serviceType ? options?.serviceType : SERVICE_OPTIONS}
        onChange={onServiceTypeChange}
        value={serviceType}
        variant="compact"
        label="Service Type"
        required
      />

      <Select
        options={options?.status ? options?.status : []}
        onChange={onStatusChange}
        value={status}
        variant="compact"
        label="Status"
        disabled={options?.status || options?.status.length === 0}
      />
      <div className="reset_option" onClick={onResetChange}>
        <img src={resetIcon} alt="reset-icon" />
        Reset
      </div>
    </div>
  );
});
